<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    import enumService from '../services/enumService'
    import afflictionTestMethodEnum from '../enums/afflictionTestMethod'
    import afflictionTestResultEnum from '../enums/afflictionTestResult'

    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                afflictionForm: () => import('../forms/AfflictionForm'),
                inspectionForm: () => import('../forms/InspectionForm'),
                fileForm: () => import('../forms/FileForm'),
                fields: [
                    { type: 'autocomplete', text: 'Inspection', value: 'inspectionId', rules: [v => !!v || 'Inspection is required'], isRequired: true, form: () => import('./InspectionForm'), apiMethod: 'Inspections', claim: 'Inspections' },
                    { type: 'autocomplete', text: 'Pest/Disease', value: 'afflictionId', rules: [v => !!v || 'Pest/Disease is required'], isRequired: true, form: () => import('./AfflictionForm'), apiMethod: 'Afflictions', claim: 'Afflictions' },
                    { type: 'enum', text: 'Pest/Disease Test Method', value: 'afflictionTestMethod', rules: [v => (v !== null && v !== '') || 'Pest/Disease Test Method is required'], isRequired: true, items: enumService.enumAsSelectList(afflictionTestMethodEnum) },
                    { type: 'enum', text: 'Pest/Disease Test Result', value: 'afflictionTestResult', rules: [v => (v !== null && v !== '') || 'Pest/Disease Test Result is required'], isRequired: true, items: enumService.enumAsSelectList(afflictionTestResultEnum) },
                    { type: 'file', text: 'Report File', value: 'reportFileId', rules: [], form: () => import('./FileForm'), apiMethod: 'Files' },
                ],
                apiMethod: 'AfflictionTests',
                formTitle: 'Pest/Disease Test',
            }
        },
    };
</script>
